export default "__VITE_ASSET__15b17b85__"